<div id="google-map" [ngStyle]="{'border-radius': radius}"></div>

<!-- Input de Pesquisa do Mapa -->
<app-multiple-select *ngIf="searchMap" class="address-map-search" (emitSelected)="handleSelected($event)"
  [option]="searchAddress" [searchMap]="searchMap">
</app-multiple-select>
<!-- Input de Pesquisa do Mapa -->
